import React, { useEffect, useState } from "react";
import edit from "../../Assets/svg/edit-icon.svg";
import Button from "../modules/Button";
import StaticItem from "../modules/StaticItem";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { api } from "../../Services";
import { addTokenInfo } from "../LoginPage/redux/actions";
import { addAllIncomeInfo } from "../IncomeDetails/redux/actions";
import { addAllEduInfo } from "../Education/redux/actions";
import { addAllPersonalInfo, addPersonalInfo } from "../PersonalInfo/redux/actions";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";

function IncomeColumn() {
  const navigate = useNavigate();
  const panList = useSelector((state) => state.income.panList);
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const idInfo = useSelector((state) => state.tokens.tokens);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);
  const education = useSelector((state) => state.education.eduInfo);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const [totalIncome, setIncome] = useState(0);
  const [Link, setLink] = useState("");
  const docs = useSelector((state) => state.tokens.tokens.docs);
  const [incomeList, setIncomeList] = useState({
    Father: "fatherIncomeCertificate",
    Mother: "motherIncomeCertificate",
    Sibling1: "sibling1IncomeCertificate",
    Sibling2: "sibling2IncomeCertificate",
    Sibling3: "sibling3IncomeCertificate",
    Guardian: "guardianIncomeCertificate",
    Myself: "incomeCertificate",
    "No-one": "noIncomeCertificate",
  });
  const btnText = () => {
    return (
      <div className="btn-text">
        <span>Income Details</span>
        <img src={edit} alt="download" />
      </div>
    );
  };

  const navigatePage = () => {
    submitData();
    let baseUrl = window.location.href.split("application/")[0];
    console.log(window.location.href.split("application/"));
    // window.location.replace(baseUrl + "application/form/income");
    navigate("/application/form/income");
  };
  const CombineData = () => {
    let data = { userId: idInfo.userId };
    let personalInfo2 = {
      ...personalInfo,
      currentAddressProof: "",
      BirthCertificate: "",
      photo: null,
      disability: [],
      personDisability: `[${personalInfo.disability}]`,
      orphan: personalInfo.orphan || "No",
    };
    let eduInfo2 = {
      ...education,
      // admissionLetter: "",
      // paymentReciept: "",
      // year: "2024-2026",
    };
    function filterAndRemove(obj) {
      for (let i in obj.membersList) {
        obj.membersList[i].doc = "";
        // obj.membersList[i].lastName = "";
      }

      return obj;
    }
    let incomeInfo2 = { ...filterAndRemove(incomeInfo) };
    let noMemeber = false;
    let memberArray = [
      "mother",
      "father",
      "sibling1",
      "sibling2",
      "sibling3",
      "guardian",
      "myself",
    ];
    for (let i = 0; i < incomeInfo2.membersList.length; i++) {
      if (
        memberArray.includes(
          incomeInfo2.membersList[i]["relationShipType"].toLowerCase()
        )
      ) {
        noMemeber = true;
        break;
      }
    }
    // let isNone=incomeInfo2.membersList.filter((a) => a["relationShipType"].toLowerCase().includes('mother'|| 'father'|| 'sibling1'||'sibling2'||"guardian"||'myself'))
    incomeInfo2 = { ...incomeInfo2, earningMember: noMemeber };
    data = {
      ...data,
      application: { id: idInfo.appId, applicationStatus: "Registered" },
    };
    data = {
      ...data,
      application: { ...data.application, personalInfo: { ...personalInfo2 } },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        incomeInfo: { ...incomeInfo2 },
      },
    };
    data = {
      ...data,
      application: {
        ...data.application,
        eduInfo: {
          ...eduInfo2,
          year: ["B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)
            ? "2024-2028"
            : "2024-2026",
        },
      },
      registration: { ...tokenData.registrationData },
      salesForceUserId: tokenData.salesForceUserId,
    };
    return data;
  };
  const destructureData = (data) => {
    if (data?.user) {
      data = data.user;
    }
    dispatch(addTokenInfo(["userId", data?.userId]));
    dispatch(addTokenInfo(["appId", data?.application?.id]));
    dispatch(addTokenInfo(["personalId", data?.application?.personalInfo?.id]));
    dispatch(addTokenInfo(["registrationData", data?.registration]));
    dispatch(addTokenInfo(["applicationData", data?.application]));
    dispatch(addTokenInfo(["salesforceUserId", data?.salesforceUserId]));
    dispatch(
      addTokenInfo(["applicationStatus", data?.application?.applicationStatus])
    );
    if (data?.application?.incomeInfo) {
      dispatch(addAllIncomeInfo(data?.application?.incomeInfo));
    }
    dispatch(addAllEduInfo(data?.application?.eduInfo));

    let personalInfo = data?.application?.personalInfo;
    personalInfo["BirthCertificate"] = ""
    dispatch(addAllPersonalInfo(personalInfo));
    let disList = [];
    if (data?.application?.personalInfo?.personDisability) {
      const disabilities = data.application.personalInfo.personDisability;
      // disList = disabilities.replace(/^\[|\]$/g, "").split(",");
      disList= disabilities.split(',')
      // .map(item => item.trim()) // Remove whitespace around elements
      .filter(item => item && item !== "[" && item !== "]" && item !== "");
      disList=disList?.map(item=>item.replace(/^\[|\]$/g, ""))
    }
    if (disList.length === 0 || disList.includes(null)) {
      disList = [];
    }
    dispatch(addPersonalInfo({ type: "disability", value: disList }));
 
    /*    let url = GetBaseUrl(window.location.href);
    if (data.user.application.applicationStatus === "Submitted") {
      navigate("/application/submitted-status");
    } else {
      navigate("/application");
    }*/
  };
  const submitData = async () => {
    try {
      let users;
      setLoading(true);
      users = await api.update(CombineData(), tokenData.token);
      // return users;
      if (users?.statusCode == 200) {
        setLoading(false);

        destructureData(users.data);
      }
    } catch (error) {
      setLoading(false);

      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    let total = 0;
    for (let i in incomeInfo.membersList) {
      total += parseInt(incomeInfo.membersList[i].income);
    }

    setIncome(total);
  }, []);
  useEffect(() => {
    let currentUrl = window.location.href;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    console.log("cleaned url", cleanedUrl);
    setLink(cleanedUrl);
  }, []);
  return (
    <div className="review-col income-col">
      {Link.split("/")[2] === "app-preview" ? (
        <div className="preview-title set-title"> Income Details</div>
      ) : (
        <Button
          type={"outlined"}
          onClickHandler={()=>navigatePage()}
          value={btnText()}
        />
      )}
      <div className="overview">
        <div className="overview-item static-item">
          <div className="item-value">Earning members of your family</div>
          <div className="members">
            {incomeInfo.membersList.map((item, index) => (
              <div key={index} className="member item-value">
                {item.relationShipType}
              </div>
            ))}
          </div>
        </div>
        {incomeInfo?.membersList[0] &&
        incomeInfo?.membersList[0]?.relationShipType === "No-one" ? (
          docs &&
          docs[incomeList[incomeInfo?.membersList[0]?.relationShipType]] && (
            <div className="doc-col no-income-col">
              <div className="doc-item">
                <StaticItem
                  type={"doc"}
                  title={"Proof of Income"}
                  // value={item?.doc?.name || ''}
                  docUrl={
                    docs[
                      incomeList[incomeInfo?.membersList[0]?.relationShipType]
                    ]?.documentUrl
                  }
                  value={
                    docs[
                      incomeList[incomeInfo?.membersList[0]?.relationShipType]
                    ].name
                  }
                  doc={
                    docs[
                      incomeList[incomeInfo?.membersList[0]?.relationShipType]
                    ]
                  }
                  size={Math.floor(
                    docs[
                      incomeList[incomeInfo?.membersList[0]?.relationShipType]
                    ].size / 1024
                  )}
                />
              </div>
            </div>
          )
        ) : (
          <div className="overview-item static-item">
            <div className="item-value">Total Family Annual Income</div>
            <div className="amount item-value">₹{totalIncome}/-</div>
          </div>
        )}
      </div>
      <div className="members-details">
        {incomeInfo?.membersList[0]?.relationShipType !== "No-one" &&
          incomeInfo.membersList.map((item, index) => (
            <div key={index} className="member-details">
              <div className="set-title">
                {!item?.relationShipType.includes("Myself")
                  ? item?.relationShipType
                  : "My"}
                {!item?.relationShipType.includes("Myself") && "'s"} Income
                Details
              </div>
              <div className="col">
                <div className="left-col">
                  <StaticItem title={"Full Name"} value={item.firstName} />
                  <StaticItem
                    mask={true}
                    title={"Mobile Number"}
                    value={item.mobile}
                  />
                  <StaticItem
                    dob={item?.dob}
                    name={item?.firstName}
                    relation={!panList[item?.relationShipType]}
                    mask={true}
                    title={"PAN"}
                    value={item.pan}
                  />
                </div>
                <div className="left-col right-item">
                  <StaticItem title={"Occupation"} value={item.occupation} />

                  <StaticItem title={"Annual Income"} value={item.income} />
                  <StaticItem title={"Date of Birth"} value={item.dob} />
                </div>
              </div>
              {/* {docs && docs[incomeList[item?.relationShipType]] && ( */}
              <div className="doc-col">
                <div className="doc-item">
                  <StaticItem
                    type={"doc"}
                    title={"Proof of Income"}
                    // value={item?.doc?.name || ''}
                    docUrl={
                      docs &&
                      incomeList[item?.relationShipType] &&
                      docs[incomeList[item?.relationShipType]]?.documentUrl
                    }
                    doc={
                      docs &&
                      incomeList[item?.relationShipType] &&
                      docs[incomeList[item?.relationShipType]]
                    }
                    value={
                      docs &&
                      incomeList[item?.relationShipType] &&
                      docs[incomeList[item?.relationShipType]]?.name
                    }
                    size={
                      docs &&
                      incomeList[item?.relationShipType] &&
                      Math.floor(
                        docs[incomeList[item?.relationShipType]]?.size / 1024
                      )
                    }
                  />
                </div>
              </div>
              {/* // )} */}
              {/* <StaticItem
              type={"doc"}
              title={"Proof of Income"}
              value={"doc value"}
            /> */}
            </div>
          ))}
      </div>

      <div className="doc-item">
        {/* <StaticItem
          type={"doc"}
          title={"Proof of Income"}
          value={"9831009988"}
        /> */}
        {/* <DocUpload
            title={"Proof of Income"}
            noTooltip={true}
            // tooltipContent={toolTipData()}
            value={props.item.doc}
            onChange={(e) => onClickhandler("doc", e)}
          /> */}
      </div>
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default IncomeColumn;
